module.exports = __webpack_public_path__ + "img/emptyBankCard.0f4279d7.png";